const CustomerTableEnum = {
  CUSTOMER: "Clients",
  ACCOUNT_NUMBER: "Account Number",
  LOCATION: "Location",
  PHONE: "Phone",
  WEBSITE: "Website",
  DESCRIPTION: "Description",
  OWNER: "Owner",
};

export default CustomerTableEnum;
